<script lang="ts">
	import { derived, writable } from 'svelte/store';
	import ReportsLoading from '../../../../../shared/components/common/Loading/ReportsLoading.svelte';
	import LocaleSelector from '../../../../../shared/components/common/LocaleSelector.svelte';
	import NoDataAvailable from '../../../../../shared/components/common/NoDataAvailable.svelte';
	import SurveyReport from '../../../../../shared/components/common/Survey/SurveyReport.svelte';
	import FiltroGenerico from '../../../../../shared/models/Filtri/FiltroGenerico';
	import Questionario from '../../../../../shared/models/Questionario/Questionario';
	import QuestionarioRisposte from '../../../../../shared/models/Questionario/QuestionarioRisposte';
	import { locale, setupI18n } from '../../../../../shared/services/i18n';
	import ProgressLoading from '../../../../../shared/components/common/Loading/ProgressLoading.svelte';

	window.localStorage.removeItem('sediRispondentiId');
	window.localStorage.removeItem('questionariSediReportId');

	let stringifiedQuestionarioJson = '';
	let stringifiedQuestionarioJsonUpdated = '';
	let risposteJson = [];
	let risposteJsonUpdated = [];

	let questionariId: number[] = localStorage.getItem('questionariAziendeReportId') !== null ? JSON.parse(localStorage.getItem('questionariAziendeReportId')) : [];
	let aziendeRispondentiId: number[] = localStorage.getItem('aziendeRispondentiId') !== null ? JSON.parse(localStorage.getItem('aziendeRispondentiId')) : [];
	let filters: FiltroGenerico = {
		questionariId: [...questionariId],
		aziendeId: [...aziendeRispondentiId],
	};
	let [dataRisposte, loadingRisposte, errorRisposte] = filters.questionariId?.length > 0 && filters?.aziendeId?.length > 0 ? QuestionarioRisposte.getList(filters) : [writable(null), writable(false), writable(null)];
	let [dataQuestionarioPerReportGrafici, loadingQuestionarioPerReportGrafici, errorQuestionarioPerReportGrafici] = [writable(null), writable(false), writable(null)];

	let [data, loading, error] = Questionario.merge(questionariId);
	
	data?.subscribe((value) => {
		if (value) {
			stringifiedQuestionarioJson = value;
		}
	});

	dataRisposte?.subscribe((value) => {
		if (value?.response?.length > 0 && value.response?.[0]?.id > 0) {
			risposteJson = [...value?.response?.map((risposta) => JSON.parse(risposta.questionarioRisposteJson))];
		}
	});

	const dataAndDataRisposte = derived(
		[loading, loadingRisposte], 
		([$loading, $loadingRisposte]) => {
			if (!$loading && !$loadingRisposte) {
				if (!stringifiedQuestionarioJson || !risposteJson.length || risposteJson.length == 0) return;
				return true;
			}
		}
	);

	dataAndDataRisposte.subscribe((value) => {
		if (value) {
			[dataQuestionarioPerReportGrafici, loadingQuestionarioPerReportGrafici, errorQuestionarioPerReportGrafici] = Questionario.prepareSurveyForGraphicReports(stringifiedQuestionarioJson, JSON.stringify(risposteJson));
		}
	});

	$: {
		if($dataQuestionarioPerReportGrafici) {
			if ($dataQuestionarioPerReportGrafici?.response?.questionarioJsonStringified) {
				stringifiedQuestionarioJsonUpdated = $dataQuestionarioPerReportGrafici?.response?.questionarioJsonStringified;
			}
			if ($dataQuestionarioPerReportGrafici?.response?.risposte) {
				risposteJsonUpdated = [...$dataQuestionarioPerReportGrafici?.response?.risposte];
			}
		}
	}
</script>

{#if $loading || $loadingRisposte || $loadingQuestionarioPerReportGrafici}
	<!--<ReportsLoading />-->
	<ProgressLoading />
{:else}
	{#if stringifiedQuestionarioJsonUpdated && risposteJsonUpdated?.length > 0}
		<div class="text-end pb-4">
			<LocaleSelector value="{$locale}" on:locale-changed="{(e) => setupI18n({ withLocale: e.detail })}" />
		</div>
		<SurveyReport bind:stringifiedQuestionarioJson={stringifiedQuestionarioJsonUpdated} bind:risposteJson={risposteJsonUpdated} />
	{:else}
		<NoDataAvailable />
	{/if}
{/if}
